import { __makeTemplateObject } from "tslib";
import { css } from '@skbkontur/react-ui/lib/theming/Emotion';
import { memoizeStyle } from '../../lib/theming/ThemeHelpers';
var styles = {
  root: function root() {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: inline-block;\n      margin-left: -1px;\n      margin-right: -1px;\n    "], ["\n      display: inline-block;\n      margin-left: -1px;\n      margin-right: -1px;\n    "])));
  },
  icon: function icon() {
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      margin-bottom: -3px;\n    "], ["\n      margin-bottom: -3px;\n    "])));
  }
};
export var jsStyles = memoizeStyle(styles);
var templateObject_1, templateObject_2;